import { ButtonProps } from '@cxc/react-fpds-components';

export const SUMMARY_PAGE_MODAL_DATA = {
    TITLE: 'Leaving Ford Pro',
    DESCRIPTION: `Do you want to continue to the grantor's website? Ford is not responsible for external content.`,
    BUTTONS: [
        {
            name: 'Cancel',
            id: 'cancel',
            size: 'medium' as const,
            buttonColor: 'default' as const,
            buttonType: 'secondary' as const,
            as: 'button' as const,
        },
        {
            name: 'Continue',
            id: 'continue',
            size: 'medium' as const,
            buttonColor: 'default' as const,
            buttonType: 'default' as const,
            as: 'button' as const,
        },
    ] as ButtonProps[],
};

export enum ButtonPlacementType {
    right = 'right',
    left = 'left',
    center = 'center',
}

export const NO_END_DATE = 'No end date';
